/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async searchSystem(keyword) {
    let data = { keyword: keyword };
    let response = await apiCall("system/find", data);
    return response;
  },

  /**
   * Result types include:- 
   * - account  
	 * - transaction  
	 * - vendor  
	 * - student
   */
  async logItem(log_id, result_type, title, subtitle, content) {
    let data = { 
      log_id:log_id,
      result_type:result_type,
      title:title,
      subtitle:subtitle,
      content: content
    }
     
    let response = await apiCall("utility/searchresult/create", data);
    return response;
  },

  async fetchRecentSearch() {
    let response = await apiCall("utility/finder/recent", []);
    return response;
  },

  async fetchSearchSuggestions() {
    let response = await apiCall("utility/searchresult/suggestions", []);
    return response;
  },
  

};
